import { createSelector } from '@reduxjs/toolkit';
import selfSelector from '../self';

const chartSelector = createSelector(selfSelector, (analytic) => analytic.chart);

export default chartSelector;